export default {
  SET_TOKEN(state, token) {
    state.token = token
    if (!token) {
      localStorage.removeItem('token')
    } else localStorage.setItem('token', token)
  },
  SET_USER(state, user) {
    state.user = user
  },
   SET_ERROR(state, error) {
    state.error = error
  },
  SET_MESSAGE(state, message) {
    state.message = message
  },
}